import React from 'react';
import Search from './Search';
import AccountInfoTab from './accountInfo/AccountInfoTab';
import AuditInfoTab from './auditInfo/AuditInfoTab';
import { SetupPage } from 'areas/shared/pages/setup';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'
import * as Help from 'modules/app/Help'
import * as Formatter from 'fw/components/formatter/Formatter';

class AccountSetup extends React.Component {
    render() {
        let opts = {
            title: "Account Setup",
            addNewTitle: "Add new account",
            description: "Create, modify, and remove account",
            addPrivilege: App.hasPrivilege("AdminAccountSetupAdd"),
            helpKey: Help.accountSetupHelpKey,
            recentType: "account",
            list: {
                url: API.Security.url('/accountSetup/search'),
                rowKey: "accountId",
                columns: [
                    { key: 'accountName', name: 'Account Name', sortable: true },
                    { key: 'address', name: 'Address' },
                    { key: 'city', name: 'City' },
                    { key: 'zip', name: 'Zip Code' },
                    { key: 'state', name: 'State' },
                    { key: 'country', name: 'Country' },
                    { key: 'active', name: 'Active', formatter: Formatter.Check, width: 100, cellClass: "text-center" }
                ]
            },
            tabs: [
                { key: "AccountInfo", title: "Account Info", comp: AccountInfoTab, helpKey: Help.accountSetupInfoHelpKey },
                { key: "AccountAudit", title: "Audit Info", comp: AuditInfoTab, helpKey: Help.accountSetupAuditHelpKey }
            ]
        };

        opts = Object.assign(opts, this.props);

        return (
            <SetupPage {...opts}
                Search={Search} />
        );
    }
}

export default AccountSetup;


// WEBPACK FOOTER //
// ./src/areas/admin/accountSetup/AccountSetup.js